import { render, staticRenderFns } from "./TableV2.vue?vue&type=template&id=18af449f&scoped=true&"
import script from "./TableV2.vue?vue&type=script&lang=js&"
export * from "./TableV2.vue?vue&type=script&lang=js&"
import style0 from "./TableV2.vue?vue&type=style&index=0&id=18af449f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18af449f",
  null
  
)

export default component.exports